import { Reveal } from "@/lib/motion";
import { FAQS } from "@/data/content";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function FAQ() {
  return (
    <section id="faq" className="py-24 lg:py-32 bg-white scroll-mt-20" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-5 sm:px-8">
        <Reveal className="text-center max-w-2xl mx-auto">
          <span className="overline text-[var(--dm-purple)]">FAQ</span>
          <h2 className="font-head font-extrabold tracking-tighter text-4xl sm:text-5xl text-slate-900 mt-4 leading-[1.05]">
            Questions? Answered.
          </h2>
        </Reveal>

        <Reveal delay={0.1} className="mt-12">
          <Accordion type="single" collapsible className="w-full space-y-3" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border border-slate-200 rounded-2xl px-5 data-[state=open]:border-[var(--dm-purple)]/40 data-[state=open]:bg-[var(--dm-alt)] transition-colors">
                <AccordionTrigger data-testid={`faq-trigger-${i}`} className="font-head font-bold text-left text-slate-900 hover:no-underline py-5 text-[1.05rem]">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 leading-relaxed text-[0.98rem] pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
